import { RootState } from "../../rootReducer";

export const selectIsLoading = (state: RootState) => state.firstSection.loading;
export const firstSectionStatusErrorMessage = (state: RootState) =>
  state.firstSection.error;
export const firstSectionDataResponse = (state: RootState) =>
  state.firstSection.firstSectionResponse;
